// AppyLogo — renders the full uploaded brand mark.
// The original asset has been background-stripped and saved as a transparent PNG
// at /public/appy-logo.png so it blends on any background.
//
// We DO NOT render an "Appy Stays" text label alongside — the logo carries the
// brand on its own.

const LOGO_URL = "/appy-logo.png";

export default function AppyLogo({ size = 44, className = "" }) {
  // Source aspect is ~685:592 ≈ 1.157:1
  return (
    <img
      src={LOGO_URL}
      alt="Appy Stays"
      style={{ height: size, width: "auto" }}
      className={`block select-none ${className}`}
      draggable={false}
    />
  );
}
